import { render, staticRenderFns } from "./DialogGenericWarning.vue?vue&type=template&id=3597d748&scoped=true&"
import script from "./DialogGenericWarning.vue?vue&type=script&lang=js&"
export * from "./DialogGenericWarning.vue?vue&type=script&lang=js&"
import style0 from "./DialogGenericWarning.vue?vue&type=style&index=0&id=3597d748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597d748",
  null
  
)

export default component.exports